export class ApprovalInvoice {
    status: number = 0;
    justification: number = 0;
    dateInvoice: Date;

    loadFromServer(r: any) {
        if(r.status)
            this.status = r.status;

        if(r.justification)
            this.justification = r.justification;

        if(r.dateInvoice)
            this.dateInvoice = r.dateInvoice;

        }
}



// WEBPACK FOOTER //
// ./src/app/models/ApprovalInvoice.model.ts